export default "__VITE_ASSET__492c3643__"